module.exports = __webpack_public_path__ + "static/media/scale5.4fc98996.png";